export default __webpack_public_path__ + "static/media/solidworks.663bc40d.png";